import script from "./HomeRepairServiceBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeRepairServiceBanner.vue?vue&type=script&setup=true&lang=js"

import "./HomeRepairServiceBanner.vue?vue&type=style&index=0&id=1fe96c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe96c2d"]])

export default __exports__